import { cn } from '@/lib/cn';

export function Skeleton({ className }: { className?: string }) {
  return (
    <span
      className={cn('shimmer inline-block h-4 w-24 rounded align-middle', className)}
      aria-hidden
    />
  );
}

export function SkeletonLine({ width = '100%' }: { width?: string | number }) {
  return <div className="shimmer h-3 rounded" style={{ width }} />;
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={cn('card flex flex-col gap-3 p-5', className)}>
      <div className="shimmer h-3 w-24 rounded" />
      <div className="shimmer h-8 w-20 rounded" />
      <div className="shimmer h-3 w-32 rounded" />
    </div>
  );
}
